export default {"src":"/_next/static/media/uv_stabilized.313b9a81.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};